import { cn } from "../../lib/cn.js";

const TONES = {
  default: "bg-bg-elevated-2 text-text-secondary border-border",
  accent: "bg-accent/15 text-accent border-accent/30",
  success: "bg-success/15 text-success border-success/30",
  warning: "bg-warning/15 text-warning border-warning/30",
  danger: "bg-danger/15 text-danger border-danger/30",
  info: "bg-accent-secondary/15 text-accent-secondary border-accent-secondary/30",
};

export function Badge({ tone = "default", className, children, ...props }) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs font-medium",
        TONES[tone],
        className
      )}
      {...props}
    >
      {children}
    </span>
  );
}
